import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ClientHeader from "../../components/Client/ClientHeader";
import Footer from "../../components/Client/Footer";
import StoreRelationRow from "../../components/Client/StoreRelationRow";
import { useAuth } from "../../context/AuthContext";
import { fetchStoreBells, unsetStoreBell } from "../../api/storeService";
import "../../components/Client/clientTheme.css";
import "./StoreRelationList.css";

export default function StoreNotifications() {
  const { t } = useTranslation(["storeNotifications", "common"]);
  const { isAuthenticated, openLoginModal } = useAuth();
  const [stores, setStores] = useState(null);
  const [error, setError] = useState(null);
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(() => {
    if (!isAuthenticated) return;
    setError(null);
    fetchStoreBells()
      .then(setStores)
      .catch(() => setError(t("loadErrorMessage")));
  }, [isAuthenticated, t]);

  useEffect(() => {
    load();
  }, [load]);

  async function handleUnsubscribe(storeId) {
    setBusyId(storeId);
    try {
      await unsetStoreBell(storeId);
      setStores((prev) => prev.filter((s) => s.storeId !== storeId));
    } catch {
      setError(t("turnOffErrorMessage"));
    } finally {
      setBusyId(null);
    }
  }

  return (
    <div className="store-relation-list-page">
      <ClientHeader />

      <div className="store-relation-list-content">
        <h1 className="store-relation-list-title">{t("pageTitle")}</h1>
        <p className="store-relation-list-subtitle">{t("pageSubtitle")}</p>

        {!isAuthenticated ? (
          <div className="store-relation-list-empty">
            <p>{t("loginPrompt")}</p>
            <button type="button" className="store-relation-list-login-button" onClick={openLoginModal}>
              {t("common:logIn")}
            </button>
          </div>
        ) : error ? (
          <div className="store-relation-list-empty">
            <p>{error}</p>
            <button type="button" className="store-relation-list-login-button" onClick={load}>
              {t("common:tryAgain")}
            </button>
          </div>
        ) : stores === null ? (
          <div className="store-relation-list-empty">
            <p>{t("loadingMessage")}</p>
          </div>
        ) : stores.length === 0 ? (
          <div className="store-relation-list-empty">
            <p>{t("emptyMessage")}</p>
          </div>
        ) : (
          <div className="store-relation-list">
            {stores.map((store) => (
              <StoreRelationRow
                key={store.storeId}
                store={store}
                actionLabel={t("turnOffAction")}
                onAction={handleUnsubscribe}
                actionBusy={busyId === store.storeId}
              />
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
